import React, { useState, useEffect } from 'react';
import { Grid, Button, FormControl, Box, InputLabel, Select, MenuItem, Input } from '@mui/material';
import FilterIcon from '@mui/icons-material/FilterList';
import { useSelector, useDispatch } from 'react-redux';
import { get, set } from 'global/lib/lodash';
import setFilter from 'redux/actions/setFilter';
import { UserFilter, FILTERDEFAULTS } from 'global/utils/filter';
import { CourseDisplay } from 'global/lib/filter';
import { useScreen } from 'global/styles';
import { FlexFilters, filterGridSx, filterFormGridSx, filterFormItemSx, filterIconSx } from 'global/styles/filters';
import DiagContainer from 'global/components/diag-container';
import { cleanCopy } from 'global/utils';

export default function PerformTasksFilters({ display, vendors }) {
  const [showFilters, setShowFilters] = useState(false);
  const filter = useSelector((state) => get(state, `filter.users.courses`, UserFilter()));
  // const authrealm = useSelector((state) => get(state, 'auth.realm'));
  // const realmid = useSelector((state) => get(state, 'auth.realm.id'));
  const dispatch = useDispatch();
  // const { status, permission } = filter; // realm_type,

  const { isMobile } = useScreen();

  useEffect(() => {
    setShowFilters(!isMobile);
  }, [isMobile]);

  // useEffect(() => {
  //   const foundInVendors = get(vendors, 'data', []).find(v => `${v.clientId}` === `${get(authrealm, 'topRealm.id')}`);
  //   if (foundInVendors && get(filter, 'client_id') !== foundInVendors.id) {
  //     changeFilter(set({ ...filter }, 'client_id', foundInVendors.id));
  //   }
  // }, [realmid, authrealm]);

  const changeFilter = (filt) => {
    dispatch(setFilter('users', 'courses', filt));
  };

  // const handleStatusChange = e => {
  //   changeFilter(set({ ...filter }, `status`, e.target.value));
  // }

  const handleDisplayChange = (e) => {
    const val = e.target.value;
    changeFilter(set({ ...filter }, 'report_type', val));
  };

  function toggleFilters() {
    setShowFilters(!showFilters);
  }

  function clearFilters() {
    changeFilter(cleanCopy(get(FILTERDEFAULTS, 'users.courses', UserFilter({ report_type: 'user' }))));
  }

  return (
    <Box sx={filterGridSx}>
      {isMobile && (
        <Button aria-label="filters" size="small" onClick={toggleFilters}>
          <FilterIcon fontSize="inherit" sx={filterIconSx} /> {showFilters ? 'Hide Filters' : 'Filters'}
        </Button>
      )}

      <DiagContainer useDialog={isMobile} title="Filters" onClose={toggleFilters} onClear={clearFilters} open={showFilters}>
        <form autoComplete="off" margin="normal">
          <Grid container>
            {/* <Grid item md={12} sx={filterFormGridSx}>
              <FlexFilters>
                <FormControl component="fieldset" sx={filterFormItemSx}>
                  <FormLabel component="legend">Status</FormLabel>
                  <RadioGroup
                    size="small" 
                    value={status} 
                    onChange={e => handleStatusChange(e)}
                  >
                    {UserStatus.map((ed, i) => 
                      <FormControlLabel
                        key={i}
                        control={<Radio />}
                        label={ed.title}
                        value={ed.value}
                      />)}
                  </RadioGroup>
                </FormControl>
              </FlexFilters>
            </Grid> */}

            <Grid item md={12} sx={filterFormGridSx}>
              <FlexFilters>
                <FormControl variant="standard" sx={filterFormItemSx}>
                  <InputLabel htmlFor="Standard-scorecard-simple">Display</InputLabel>
                  <Select value={get(filter, 'report_type')} onChange={handleDisplayChange} input={<Input name="scorecard" id="Standard-scorecard-simple" />}>
                    {CourseDisplay.map((course) => {
                      return (
                        <MenuItem key={course.value} value={course.value}>
                          {course.title}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </FlexFilters>
            </Grid>
          </Grid>
        </form>
      </DiagContainer>
    </Box>
  );
}
